/**
 * 供应商 表单验证规则
 * @author zjs
 * @time 2017-12-12
 */
export default {
    data () {
        return {
            formRules: {
                'provider_code' : [{ required: true, trigger: 'blur' }],
                'provider_name': [{ required: true, trigger: 'blur' }]
            }
        }
    }
}